import { ERoutes } from 'shared/types/routes'

export const hiddenRightContainerRoutesList: Array<string> = [
  ERoutes.Root,
  ERoutes.Profile
]

export const maxAmountSumValue = 500000000
